import { getLocales } from 'assets/locales/Locale';
import AlertBox from 'assets/other/AlertBox';
import Theme from 'assets/themes/Theme.Common';
import { useSalesContractProvider } from '../../Sales.Contract.Hooks';

const ContractInfoAlerts = () => {
  const { lang } = getLocales();
  const { selected } = useSalesContractProvider();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: Theme.Size.L }}>
      <h2>{lang.alertsAndNotifications}</h2>
      <AlertBox alerts={selected?.contractAlerts} />
    </div>
  );
};

export default ContractInfoAlerts;
